import React, { useEffect, useState } from "react";
import { Box, IconButton, List, Typography } from "@mui/material";
import { makeStyles, styled } from "@mui/styles";
import MuiDrawer from "@mui/material/Drawer";
import { connect } from "react-redux";
import SideBarMenuItem from "Components/Common/SideBarCommanList";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { ReactComponent as RepeatSmart } from "Assets/Logo/RepeatSmart.svg";
import { ReactComponent as RepeatSmartApp } from "Assets/Logo/RepeatSmartApp.svg";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { setLocalStorage } from "utils/generalUtils";
const drawerWidth = 260;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: "60px",
});

const useStyle = makeStyles((theme) => ({
  rsDrawerRoot: {
    transition: "none !important",
    "&>div": {
      marginTop: "65px",
      transition: "none !important",
      zIndex: "999 !important",
    },
  },
  rsDrawerRootOpen: {
    transition: "none !important",
    "&>div": {
      marginTop: "65px",
      transition: "none !important",
      zIndex: "1500 !important",
    },
  },
  rsDrawerRootopen: {
    // transition: "none !important",
    "&>div": {
      marginTop: "60px",
      // transition: "none !important",
      zIndex: "999 !important",
    },
  },
  rsDrawerListRoot: {
    marginBottom: "70px !important",
    padding: "7px 0px !important",
    "&>li": {
      "& .MuiListItemButton-root": {
        padding: "14px 6px 14px 12px",
        borderRadius: "4px",
      },
      "& .MuiListItemText-root": {
        marginTop: "0px",
        marginBottom: "0px",
        marginLeft: "0px",
      },
    },
    "& h2": {
      // marginBottom: "30px",
      marginBottom: "0px",
      cursor: "pointer",
    },
  },
  sideDrawerIcon: {
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
  },
  rspinBtn: {
    "&>svg": {
      "&>path": {
        fill: "#7bbd4b",
      },
      "&>g": {
        "&>path": {
          fill: "#7bbd4b",
        },
      },
    },
  },
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      boxShadow: "0px 0px 10px rgba(26, 102, 122, 0.1)",
      borderRight: "unset",
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      boxShadow: "0px 0px 10px rgba(26, 102, 122, 0.1)",
      borderRight: "unset",
    },
  }),
}));

function SideDrawer({
  open,
  setOpen,
  loginUserDetail,
  pin,
  setPin,
  welcomeDialog,
  setWelcomeDialog,
}) {
  const classes = useStyle();

  return (
    <Drawer
      onMouseEnter={() => {
        if (pin == true) {
        } else {
          setOpen(true);
        }
      }}
      onMouseLeave={() => {
        if (pin == true) {
        } else {
          setOpen(false);
        }
      }}
      variant="permanent"
      open={open}
      className={pin == false && open ? classes.rsDrawerRootOpen : classes.rsDrawerRoot}
    >
      <List className={classes.rsDrawerListRoot}>
        {/* <Typography
          style={{
            textAlign: open ? "left" : "center",
            marginLeft: open ? "10px" : "0px",
            height: "70px",
          }}
          variant="h2"
          semiBold
          color="primary"
        >
          {!open ? (
            <PrimaryIcon
              style={{
                width: "37px",
                height: "65px",
                marginLeft: "10px",
                // marginBottom: "-22px",
              }}
              icon={RepeatSmartApp}
              cursor="pointer"
            />
          ) : (
            <Box className={classes.sideDrawerIcon}>
              <PrimaryIcon
                style={{
                  width: "231px",
                  height: "65px",
                  marginLeft: "10px",
                }}
                icon={RepeatSmart}
                cursor="pointer"
              />
              {pin ? (
                <Box>
                  <IconButton
                    className={classes.rspinBtn}
                    onClick={() => {
                      setPin(!pin);
                      setOpen(true);
                      setLocalStorage("pinSideDrawer", "false");
                    }}
                  >
                    <FactCheckIcon />
                  </IconButton>
                </Box>
              ) : (
                <Box>
                  <IconButton
                    className={classes.rspinBtn}
                    onClick={() => {
                      setPin(!pin);
                      setLocalStorage("pinSideDrawer", "true");
                    }}
                  >
                    <FactCheckOutlinedIcon />
                  </IconButton>
                </Box>
              )}
            </Box>
          )}
        </Typography> */}
        <SideBarMenuItem
          loginUserDetail={loginUserDetail}
          open={open}
          welcomeDialog={welcomeDialog}
          setWelcomeDialog={setWelcomeDialog}
        />
      </List>
    </Drawer>
  );
}

const mapStateToProps = (state) => ({
  loginUserDetail: state.user.loginUserDetail,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SideDrawer);
